import React, { useEffect, useState } from "react";
import {
  FaFacebook,
  FaSnapchatGhost,
  FaTiktok,
  FaInstagram,
  FaStar,
} from "react-icons/fa";
import {
  FiGift,
  FiCamera,
  FiShoppingBag,
  FiHeart,
  FiSmartphone,
  FiDollarSign,
} from "react-icons/fi";
import { MdConfirmationNumber, MdOutlineCreditCardOff } from "react-icons/md"; // General Admission
import { TbSpeakerphone } from "react-icons/tb"; // Front Row
import { AiFillStar } from "react-icons/ai"; // VIP
import { HiArrowNarrowRight, HiOutlineMicrophone } from "react-icons/hi"; // Backstage Pass
import loyaltyApi from "api/loyalty/loyaltyApi";
import { useNavigate } from "react-router-dom";
import StampsTemplate from "../../containers/LoyaltyWallet/components/StampTemplate";

const TiersProgress = ({ currentStep = 0 }) => {
  const tiers = [
    { label: "GENERAL ADMISSION", icon: <MdConfirmationNumber size={36} /> },
    { label: "FRONT ROW", icon: <TbSpeakerphone size={36} /> },
    { label: "VIP", icon: <AiFillStar size={36} /> },
    { label: "BACKSTAGE PASS", icon: <HiOutlineMicrophone size={36} /> },
  ];

  return (
    <section className="text-center py-12 bg-dry text-white">
      <h2 className="text-2xl md:text-3xl font-bold mb-10 uppercase">
        Get the Backstage Pass!
      </h2>

      {/* Tier Icons */}
      <div className="flex justify-center items-center flex-wrap gap-8 mb-8">
        {tiers.map((tier, idx) => (
          <div key={idx} className="flex flex-col items-center">
            <div
              className={`w-20 h-20 md:w-24 md:h-24 flex items-center justify-center rounded-full border-2 text-3xl ${
                idx <= currentStep
                  ? "text-yellow-400 border-yellow-400 shadow-yellow-400 shadow-md animate-pulse"
                  : "text-white border-white"
              }`}
            >
              {tier.icon}
            </div>
            <p className="mt-2 text-xs font-bold uppercase">{tier.label}</p>
          </div>
        ))}
      </div>

      {/* Progress Bar */}
      <div className="flex justify-center items-center gap-2 text-xs">
        {tiers.map((_, idx) => (
          <React.Fragment key={idx}>
            {/* Dot */}
            <div
              className={`w-3 h-3 rounded-full ${
                idx <= currentStep
                  ? "bg-yellow-400 shadow-md shadow-yellow-500"
                  : "border border-yellow-400 bg-transparent"
              }`}
            />
            {/* Arrow between steps */}
            {idx < tiers.length - 1 && (
              <div className="flex items-center gap-1">
                <div className="w-6 h-px border-b-2 border-dotted border-white" />
                <HiArrowNarrowRight
                  className={`text-white ${
                    idx < currentStep ? "text-yellow-400 animate-pulse" : ""
                  }`}
                />
                <div className="w-6 h-px border-b-2 border-dotted border-white" />
              </div>
            )}
          </React.Fragment>
        ))}
      </div>
    </section>
  );
};
const perks = [
  "One time discount for entering the tier",
  "Birthday reward",
  "Early access to sales",
  "Anniversary discount",
  "Exclusive loyalty sales",
  "Entry to our monthly $100 gift card draw",
  "Entry to our monthly Insta feature draw",
  "Early access to new product launches",
  "Exclusive access to our stylist Facebook group",
  "Customer service priority response",
  "Exclusive Princess Polly merch",
  "Invites to Princess Polly events",
  "Go in the draw for a festival weekend with Princess Polly",
];

const tiers = [
  {
    name: "General Admission",
    points: "1-299 POINTS",
    perks: ["15%", "$10", "★", "$5", "", "", "", "", "", "", "", "", ""],
  },
  {
    name: "Front Row",
    points: "300-699 POINTS",
    perks: ["20%", "$15", "★", "$10", "★", "★", "★", "", "", "", "", "", ""],
  },
  {
    name: "VIP",
    points: "700-2499 POINTS",
    perks: ["25%", "$20", "★", "$15", "★", "★", "★", "★", "★", "★", "", "", ""],
  },
  {
    name: "Backstage Pass",
    points: "2500+ POINTS",
    perks: [
      "30%",
      "$25",
      "★",
      "$20",
      "★",
      "★",
      "★",
      "★",
      "★",
      "★",
      "★",
      "★",
      "★",
    ],
  },
];

const PerksTable = () => {
  return (
    <section className="overflow-x-auto py-12">
      <h2 className="text-center text-2xl md:text-3xl font-bold uppercase mb-8">
        All the Perks
      </h2>
      <table className="min-w-full border border-border text-sm text-center">
        <thead className="bg-textGray text-text uppercase">
          <tr>
            <th className="border border-black px-4 py-2">Perks</th>
            {tiers.map((tier, idx) => (
              <th key={idx} className="border border-black px-4 py-2">
                <div className="font-bold">{tier.name}</div>
                <div className="text-xs">{tier.points}</div>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {perks.map((perk, i) => (
            <tr key={i} className={`${i % 2 === 0 ? "bg-dry" : ""}`}>
              <td className="border border-border px-4 py-2 text-left font-semibold">
                {perk}
              </td>
              {tiers.map((tier, j) => (
                <td key={j} className="border border-border px-4 py-2">
                  {tier.perks[i]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </section>
  );
};

const LoyaltyRewards = ({ joinRoyalNumber, operator, operatorId }) => {
  const [card, setCard] = useState(null);

  useEffect(() => {
    const fetchCard = async () => {
      try {
        const { response, err } = await loyaltyApi.getCardDesignByWriter(
          operatorId
        );

        console.log({ response });

        if (err) {
          console.error(err.message || "No card design found for operator");
          return;
        }

        setCard(response);
      } catch (error) {
        console.error("API error:", error);
      }
    };

    fetchCard();
  }, []);

  console.log({ card });

  const getBonusIndexes = (stampsselected) => {
    if (stampsselected <= 5) return [stampsselected - 1];
    const numBonuses = stampsselected <= 10 ? 2 : stampsselected <= 15 ? 3 : 4;
    return Array.from(
      { length: numBonuses },
      (_, i) => Math.round(((i + 1) / numBonuses) * stampsselected) - 1
    );
  };

  const navigate = useNavigate();

  const bonusIndexes = getBonusIndexes(card?.stampsselected);
  const upcomingBonusIndex = bonusIndexes.find(
    (idx) => card?.stampCount === idx
  );

  const extendedCard = {
    rewardDetails:
      card?.cardDesc4 ||
      "Get $10 off your next purchase after collecting all stamps.",
    terms:
      card?.cardDesc5 ||
      "No partial redemptions. Stamps cannot be exchanged or redeemed for cash.",
    contactInfo: card?.cardDesc3 || "Unknown Store",
    cardColor: card?.CardColor || "#FFC70B",
  };

  return (
    <section className="w-full  text-text py-10 px-4">
      {/* Hero Section */}
      <div className="text-center mb-12">
        <h1 className="text-xl md:text-xl font-extrabold uppercase">
          Welcome to
        </h1>
        <h2 className="text-xl md:text-xl font-black uppercase">
          Royalty Rewards
        </h2>
        <div className="mt-6 flex justify-center gap-4">
          {/* <button className="bg-black text-white px-6 py-2 uppercase font-semibold">
            Log in
          </button> */}
          {joinRoyalNumber > 0 && (
            <div className="flex items-center gap-2 px-3 py-1 bg-red-100 text-redlight rounded-full shadow-md">
              <FiGift className="w-5 h-5" />
              <span className="font-medium">
                You have joined Loyalty Program
              </span>
            </div>
          )}
          {/* <button className="bg-yellow-200 px-6 py-2 uppercase font-semibold">
            Join Now
          </button> */}
        </div>
        <p className="mt-4 text-sm max-w-xl mx-auto italic text-textGray">
          As a Royalty Rewards member, you'll get access to exclusive offers,
          sales, discounts + early access to giveaways and other cool perks!
        </p>
        <button
          onClick={() => navigate("/loyaltywallets")}
          className="mx-auto mt-4 py-2 px-4 flex items-center justify-center space-x-2 rounded-full text-sm font-semibold shadow-lg transition-all duration-300 transform hover:scale-105 focus:outline-none focus:ring-4 text-white bg-gradient-to-r from-red-500 to-pink-500"
        >
          Wallets
        </button>
      </div>
      {/* //---------- card detail -------------------  */}
      {card ? (
        <div className="flex flex-col lg:flex-row gap-4 mx-auto  justify-center">
          <div
            className={`rounded-xl p-5 min-h-[250px] max-w-[400px] flex flex-col justify-between overflow-hidden w-full lg:w-1/2`}
            style={{
              backgroundImage: `linear-gradient(to top right, #00000050, ${
                card?.CardColor || "#38BDF8"
              })`,
            }}
          >
            <div className="flex justify-between items-center">
              <div className="flex items-center gap-2 cursor-pointer">
                <img
                  src={operator.photo}
                  alt={operator.name}
                  className="w-8 h-8 rounded-full object-cover border border-white"
                />
                <h2 className="text-lg font-semibold text-white whitespace-nowrap">
                  {operator.name}
                </h2>
              </div>
              <div className="flex items-center gap-1">
                <div className="flex items-center gap-2 text-white text-sm">
                  <span>
                    {card?.stampCount}/{card?.NoofStamps}
                  </span>
                </div>
                {upcomingBonusIndex !== undefined && (
                  <div className="bg-redlight text-text text-xs px-2 py-1 rounded-full flex items-center gap-1 shadow-md animate-pulse">
                    <FaStar size={12} />
                    Bonus {bonusIndexes.indexOf(upcomingBonusIndex) + 1}!
                  </div>
                )}
              </div>
            </div>

            <div className="py-3 flex justify-start">
              <>
                <div>
                  <StampsTemplate
                    stampsselected={card.NoofStamps || 0}
                    stampCount={card.NoOfStamp || 0}
                    pickImg={card.PickImg || ""}
                    pickunImg={card.PickImg || ""}
                    stampedBackground={card.StampColor || "#ccc"}
                    unstampedBackground={card.unStampColor || "#eee"}
                    bonusList={[]}
                  />
                </div>
              </>
            </div>

            <div className="flex justify-between items-center text-white text-sm">
              <div>.... {card?.writer?._id?.slice(-4)}</div>
              <div>LOYALTY</div>
            </div>
          </div>

          <div
            className={`rounded-xl p-5 min-h-[250px] max-w-[400px] flex flex-col justify-between overflow-hidden w-full lg:w-1/2`}
            style={{
              backgroundImage: `linear-gradient(to top right, ${card?.CardColor}, #0f0f0f)`,
            }}
          >
            <div className="space-y-2 text-sm leading-snug overflow-hidden">
              <p className="text-sm text-white/90">
                💰 Spend{" "}
                <span className="font-bold">${card?.ValueToGetStamp}</span> per
                stamp.
              </p>
              <p className="font-semibold text-white">🎁 {card?.cardDesc4}</p>
              <p className="text-white/80 text-xs whitespace-pre-line">
                {card?.cardDesc5}
              </p>
            </div>

            <div className="flex justify-between items-center text-xs mt-2">
              <span className="tracking-wide">
                Contact:{" "}
                <span className="font-semibold">{card?.writer?.email}</span>{" "}
              </span>
              <span className="italic opacity-80">*T&Cs apply</span>
            </div>
          </div>
        </div>
      ) : (
        <div className="min-h-[250px] flex flex-col items-center justify-center text-center p-6">
          <MdOutlineCreditCardOff className="text-red-400 text-6xl mb-4 animate-pulse" />
          <p className="text-lg font-medium text-gray-500">No card found</p>
          <p className="text-sm text-gray-400 mt-1">
            Sample loyalty cards will appear here once available.
          </p>
        </div>
      )}

      {/* //---------- card detail       -------------------  */}
      {/* How it works */}
      <div className="text-center my-16 mx-auto">
        <h3 className="text-2xl font-bold mb-8 uppercase">How It Works</h3>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 max-w-4xl mx-auto text-sm">
          <div>
            <div className="text-3xl font-bold mb-2">1</div>
            <p>
              Show your QR
              <br />
              to start earning points
            </p>
          </div>
          <div>
            <div className="text-3xl font-bold mb-2">2</div>
            <p>
              Earn points
              <br />
              from your purchases
            </p>
          </div>
          <div>
            <div className="text-3xl font-bold mb-2">3</div>
            <p>
              Receive rewards
              <br />
              incl. exclusive offers, sales & discounts
            </p>
          </div>
        </div>
      </div>
      {/* Ways to Earn Points */}
      {joinRoyalNumber < 0 && (
        <div className="text-center">
          <h3 className="text-2xl font-bold mb-10 uppercase">
            Ways to Earn Points
          </h3>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-6 max-w-5xl mx-auto text-sm">
            <PointItem
              icon={<FiDollarSign size={28} />}
              label="+1 point"
              sub="per $ spent"
            />
            <PointItem
              icon={<FiShoppingBag size={28} />}
              label="+50 points"
              sub="every 3rd shop with us"
            />
            <PointItem
              icon={<FiCamera size={28} />}
              label="+10 points"
              sub="leave a product review"
            />
            <PointItem
              icon={<FaInstagram size={28} />}
              label="+5 points"
              sub="follow us on Instagram"
            />
            <PointItem
              icon={<FaFacebook size={28} />}
              label="+5 points"
              sub="follow us on Facebook"
            />
            <PointItem
              icon={<FaSnapchatGhost size={28} />}
              label="+5 points"
              sub="follow us on Snapchat"
            />
            <PointItem
              icon={<FaTiktok size={28} />}
              label="+5 points"
              sub="follow us on TikTok"
            />
            <PointItem
              icon={<FiGift size={28} />}
              label="A lil’ gift"
              sub="on your birthday!"
            />
            <PointItem
              icon={<FiSmartphone size={28} />}
              label="+10 points"
              sub="sign up for texts"
            />
            <PointItem
              icon={<FiHeart size={28} />}
              label="+20 points"
              sub="refer a friend"
            />
          </div>
          <TiersProgress />
          <PerksTable />
        </div>
      )}
    </section>
  );
};

const PointItem = ({
  icon,
  label,
  sub,
}: {
  icon: React.ReactNode,
  label: string,
  sub: string,
}) => (
  <div className="flex flex-col items-center text-center">
    <div className="mb-2 text-text">{icon}</div>
    <div className="font-bold">{label}</div>
    <p className="text-xs text-textGray mt-1">{sub}</p>
  </div>
);

export default LoyaltyRewards;
